import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import RoleManagerSection from "../../Sections/RoleManager";

const RoleManagerComponent = () => {
    return (
        <Dashboard sectionName={<RoleManagerSection />}/>
    );
};

export default RoleManagerComponent;
